<div class="wk-keyword-and-definition">
  <header mat-dialog-header>
    <h3 class="mb-0" mat-dialog-title>
      {{ 'APP.KEYWORDS_DEFINITION.KEYWORDS_AND_DEFINITION_TITLE' | translate }}
    </h3>

    <button mat-icon-button class="close-icon" (click)="closeDialog()">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <section class="section">
    <div class="wk-insert-keyword-and-definition">
      <section class="section">
        <wk-keyword-editor
          [keywordEditorString]="keywordEditorString"
        ></wk-keyword-editor>
        <wk-definition-editor [definitionEditorString]="definitionEditorString">
        </wk-definition-editor>
      </section>
    </div>

    <div class="action-buttons">
      <button class="wk-button wk-button-text" (click)="closeDialog()">
        {{ 'APP.KEYWORDS_DEFINITION.CANCEL_BUTTON' | translate }}
      </button>
      <button
        *ngIf="!isEditKeyword"
        class="wk-button"
        type="submit"
        [disabled]="isAddDisable"
        (click)="onAddKeyTermAndDefinition()"
      >
        {{ 'APP.KEYWORDS_DEFINITION.ADD_BUTTON' | translate }}
      </button>
      <button
        *ngIf="isEditKeyword"
        class="wk-button"
        type="submit"
        [disabled]="isAddDisable"
        (click)="onAddKeyTermAndDefinition()"
      >
        {{ 'APP.KEYWORDS_DEFINITION.SAVE_CHANGES_BUTTON' | translate }}
      </button>
    </div>
  </section>
</div>
